import Vue from 'vue'

/**
 * @author Jose Luis R
 * Comprehensive Privacy Notice
 */

export default () =>
  Vue.$http.put(`/users/current/comprehensive_privacy_notice/`)
    .then((res) => res.data)
